import React from 'react'
import { AddFormToCRMButton, AddFormToCustomButton } from './AddFormToCRMButton'
import { AiFeature } from '../../../../../models/AiFeature'
import { IntegrationServiceId } from '../../../../../common/integrations'
import { AIAgentResult } from '../../../../../models/AIAgent'
import { Me, User } from '../../../../../models/User'

interface AddFormToCRMButtonsProps {
  aiFeature: AiFeature
  formResult: AIAgentResult
  contact: User | null
  currentUser: Me | null
}

export const AddFormToCRMButtons: React.FC<AddFormToCRMButtonsProps> = ({ aiFeature, formResult, contact, currentUser }) => {
  return (
    <div className='d-flex gap-2'>
      <AddFormToCRMButton
        aiFeature={aiFeature}
        formResult={formResult}
        contact={contact}
        serviceId={IntegrationServiceId.WEALTHBOX}
        currentUser={currentUser}
      />
      <AddFormToCRMButton
        aiFeature={aiFeature}
        formResult={formResult}
        contact={contact}
        serviceId={IntegrationServiceId.SALESFORCE}
        currentUser={currentUser}
      />
      <AddFormToCRMButton aiFeature={aiFeature} formResult={formResult} contact={contact} serviceId={IntegrationServiceId.REDTAIL} currentUser={currentUser} />
      <AddFormToCRMButton aiFeature={aiFeature} formResult={formResult} contact={contact} serviceId={IntegrationServiceId.PRACTIFI} currentUser={currentUser} />
      <AddFormToCRMButton aiFeature={aiFeature} formResult={formResult} contact={contact} serviceId={IntegrationServiceId.XLR8} currentUser={currentUser} />
      <AddFormToCRMButton aiFeature={aiFeature} formResult={formResult} contact={contact} serviceId={IntegrationServiceId.ZOHO} currentUser={currentUser} />
      <AddFormToCRMButton aiFeature={aiFeature} formResult={formResult} contact={contact} serviceId={IntegrationServiceId.DYNAMICS} currentUser={currentUser} />
      <AddFormToCRMButton
        aiFeature={aiFeature}
        formResult={formResult}
        contact={contact}
        serviceId={IntegrationServiceId.SMARTOFFICE}
        currentUser={currentUser}
      />
      <AddFormToCRMButton aiFeature={aiFeature} formResult={formResult} contact={contact} serviceId={IntegrationServiceId.HUBSPOT} currentUser={currentUser} />
      <AddFormToCRMButton aiFeature={aiFeature} formResult={formResult} contact={contact} serviceId={IntegrationServiceId.ELEMENTS} currentUser={currentUser} />
      <AddFormToCRMButton
        aiFeature={aiFeature}
        formResult={formResult}
        contact={contact}
        serviceId={IntegrationServiceId.BLACK_DIAMOND}
        currentUser={currentUser}
      />
      <AddFormToCRMButton aiFeature={aiFeature} formResult={formResult} contact={contact} serviceId={IntegrationServiceId.ENGAGE} currentUser={currentUser} />
      <AddFormToCRMButton
        aiFeature={aiFeature}
        formResult={formResult}
        contact={contact}
        serviceId={IntegrationServiceId.ADVISOR_ENGINE}
        currentUser={currentUser}
      />
      <AddFormToCustomButton aiFeature={aiFeature} formResult={formResult} contact={contact!} serviceId={IntegrationServiceId.CUSTOM} />
    </div>
  )
}
